import API from "@/API";
import loader from "../../creators/loader";
import dataTableCreator from "@/store/creators/dataTable";

const SET_PROFESSIONAL = "SET_PROFESSIONAL";

const state = {
  professional: {},
  headers: [
    { value: "data-table-expand" },
    { text: "Nome", value: "name" },
    { text: "Situação", value: "expires_at" },
    { text: "Validade", value: "expires_at" },
    { text: "Data de Criação", value: "created_at", sortable: false },
    { text: "Desconto", value: "value", sortable: false },
    { text: "Máximo de usos", value: "usage_count", sortable: false },
    { text: "Nº de usos", value: "", sortable: false },
    { text: "Açoes", value: "", sortable: false }
  ]
};

const actions = {
  setProfessional({ state, commit, dispatch }, professional) {
    if (state.professional === professional) return;
    commit("SET_PROFESSIONAL", professional);
    dispatch("resetDataTable");
  },

  async getItems({ dispatch, state }) {
    dispatch("startLoader");

    try {
      const results = await API.ProfessionalCoupons.index(
        state.professional.account.id,
        state.options.page
      );
      dispatch("setTotalItems", results.totalItems);
      dispatch("setItems", results.data);
    } catch (e) {
      dispatch("clearItems");
      dispatch("stopLoader");
      throw e;
    }

    dispatch("stopLoader");
  },

  async createCoupon({ commit, state }, coupon) {
    try {
      return await API.ProfessionalCoupons.create(
        state.professional.account.id,
        coupon
      );
    } catch (_) {
      throw "Tivemos um erro ao criar o cupom da profissional! Tente novamente ou chame um dev para ajudar :)";
    }
  },

  async updateCoupon({ commit }, coupon) {
    try {
      return await API.ProfessionalCoupons.update(coupon);
    } catch (_) {
      throw "Tivemos um erro e não foi possível atualizar o cupom da profisisonal. Tente novamente ou chame um dev para ajudar :)";
    }
  },

  async getCoupon({ commit }, couponId) {
    try {
      return await API.ProfessionalCoupons.getById(couponId);
    } catch (_) {
      throw "Não foi possível buscar o cupom!";
    }
  }
};

const mutations = {
  [SET_PROFESSIONAL](state, professional) {
    state.professional = professional;
  }
};

export default {
  namespaced: true,
  state: {
    ...loader.state,
    ...dataTableCreator.state,
    ...state
  },
  actions: {
    ...loader.actions,
    ...dataTableCreator.actions,
    ...actions
  },
  mutations: {
    ...loader.mutations,
    ...dataTableCreator.mutations,
    ...mutations
  },
  getters: dataTableCreator.getters
};



// WEBPACK FOOTER //
// ./src/store/modules/professionals/coupons.js